<template>
  <div class="index-container">
    <div class="sidebar bs-10">
      <span v-on:click="$router.push('/contact')"><i class="el-icon-phone-outline"></i><span class="icon-name">Contact Us</span></span>
    </div>
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './Header.vue'
  import Main from './Main.vue'
  import Footer from './Footer.vue'
  export default {
    name: 'Index',
    components: {
      Header,
      Main,
      Footer
    },
    data() {
      return {

      }
    },
    methods: {

    },
    mounted: function () {

    }
  }
</script>

<style scoped>
  .index-container {
    background: linear-gradient(-45deg, hsla(33, 31%, 72%, .3), hsla(33, 31%, 72%, .3) 25%, transparent 0, transparent 50%, hsla(33, 31%, 72%, .3) 0, hsla(33, 31%, 72%, .3) 75%, transparent 0, transparent);
    background-size: 5px 5px;
  }
  .sidebar{
    width:64px;
    height: 50px;
    position:fixed;
    right:0;
    bottom: 50%;
    /*background-color: rgb(193, 230, 198);*/
    background-color: #FFF;
    border-radius: 8px 8px 8px 8px;
    padding: 10px;
    cursor: pointer;
    z-index: 999;
  }
  .sidebar i{
    font-size: 32px;
  }
  .sidebar span{
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue